import { get, patch, del, post } from "helpers/api_helper"
import { invalidateEventCacheAfterSuccess } from "../../../../../eventCachePolicy"

export const getPenalties = async competitionId => {
  let response
  try {
    response = await get(`/penalties/${competitionId}`)
  } catch (error) {
    console.log(error)
  }
  return response
}

export const addPenalties = async ({ socketClientId, id, penalty }) => {
  let response

  try {
    response = await post(`/admin/accounts/${id}/penalties`, {
      socketClientId,
      penalty,
    })
    invalidateEventCacheAfterSuccess(response)
  } catch (error) {
    console.log(error)
  }

  return response
}

export const updatePenalties = async ({
  penaltyId,
  userId,
  penalty,
  socketClientId,
}) => {
  let response
  try {
    response = await patch(`/admin/accounts/${userId}/penalties/${penaltyId}`, {
      ...penalty,
      socketClientId: socketClientId,
    })
    invalidateEventCacheAfterSuccess(response)
  } catch (error) {
    console.log(error)
  }
  return response
}

export const updatePenaltiesStatus = async (userId, id, type) => {
  let response
  try {
    response = await patch(`/admin/accounts/${userId}/penalties/${id}/${type}`)
    invalidateEventCacheAfterSuccess(response)
  } catch (error) {
    console.log(error)
  }
  return response
}

export const DeletePenalties = async (userId, id) => {
  let response
  try {
    response = await del(`/admin/accounts/${userId}/penalties/${id}/deleted`)
    invalidateEventCacheAfterSuccess(response)
  } catch (error) {
    console.log(error)
  }
  return response
}
